import { useQuery } from '@tanstack/react-query';
import { API } from '~/shared/API/api';

export const useGetPaymentInfo = (id: string | null) => {
  const { data, isLoading, refetch, isSuccess } = useQuery({
    queryKey: ['payment', id],
    enabled: id !== null,
    queryFn: () => API.getPaymentInfo(id as string),
    //retry: 1,
    select: (data) => data.data,
    refetchOnWindowFocus: 'always',
    refetchInterval: 1500,
  });

  return { paymentInfo: data, isLoading, refetch, isSuccess };
};
